import { Advanced_Dropdown_Widget } from "./base/class.advanced-dropdown-widget";

/**
 * Implements the features for the advanced dropdown currency selector widget, which
 * is rendered with HTML elements instead of a basic <select> field.
 *
 * @since 4.12.1.210629
 */
export class Dropdown_Currency_Selector_Widget extends Advanced_Dropdown_Widget { // NOSONAR
	/**
	 * The argument passed with POST requests to select a currency.
	 */
	protected ARG_CURRENCY = 'aelia_cs_currency';

	/**
	 * Returns a jQuery element matching all the selector widgets handled by this class.
	 *
	 * @returns JQuery
	 */
	protected get_all_dropdowns(): JQuery {
		return jQuery('.wc_aelia_cs_currency_selector.active').find('.dropdown');
	}

	/**
	 * Initialise the event handlers used by the widget.
	 */
	protected init_event_handlers(): void {
		super.init_event_handlers();

		// Advanced dropdown selector widget (custom HTML, flags)
		// Activate the currency selector dropdown when the selector is clicked
		jQuery(document).on('click', '.wc_aelia_cs_currency_selector .selected_currency', (event: Event): void => { // NOSONAR
			this.toggle_dropdown(event, jQuery(event.currentTarget).parents('.wc_aelia_cs_currency_selector').first());
		});

		// Intercepts the currency selection and reloads the page with the new currency
		jQuery(document).on('click', '.wc_aelia_cs_currency_selector .currency', (event: Event): void => { // NOSONAR
			this.submit_selection(jQuery(event.currentTarget).data('value'));
		});

		// Basic dropdown selector widget
		// Monitor the "on change" at the document level, to intercept the currency selection
		// in widgets created on the fly (e.g. by page builders)
		// @since 4.7.11.190924
		jQuery(document).on('change', '.widget_wc_aelia_currencyswitcher_widget .aelia_cs_currencies', (event: Event): void => { // NOSONAR
			event.stopPropagation();
			this.submit_selection(jQuery(event.currentTarget).val().toString());
		});
	}

	/**
	 * Intercepts the currency selection and performs a POST request to update the page.
	 *
	 * @param selected_value
	 * @returns void
	 */
	protected submit_selection(selected_value: string): void {
		if(!selected_value) {
			return;
		}

		// Trigger an event to indicate that a currency has been selected. This will purge the
		// cart fragments before submitting the selection, and ensure that the cart fragments
		// are fetched "fresh", using the new currency
		jQuery(document).trigger('aelia_currency_selected');

		// Create an <input> element to contain the currency
		const currency_field: HTMLInputElement = document.createElement('input');
		currency_field.type = 'hidden';
		currency_field.name = this.ARG_CURRENCY;
		currency_field.value = selected_value;

		// Create a hidden <form> element that will be used to send the POST request
		const form: HTMLFormElement = document.createElement('form');
		form.classList.add('currency_switch_form');
		form.method = 'post';
		form.style.display = 'none !important';
		form.appendChild(currency_field);
		document.body.appendChild(form);

		// Submit the form
		form.submit();
	}
}